var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "error-msg !block relative bg-[#F9E8E8] p-[15px_20px_15px_20px] mb-[1rem]"
  }, [_c('i', {
    staticClass: "el-icon-warning absolute w-[24px] h-[24px] text-[24px] text-[#C51C1C]"
  }), _c('div', {
    staticClass: "pl-[4rem]"
  }, [_c('div', {
    staticClass: "msg-title text-[18px] text-[#C51C1C] font-semibold"
  }, [_vm._v(" " + _vm._s(_vm.$t('Login Failed')) + " ")]), _c('div', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.message))])])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };